<template>
  <div
    v-clicking-outside-directive="onClickedOutside"
    :style="style"
    class="neuron-multiple-input-group n-cursor-pointer tw-w-full"
  >
    <div class="neuron-multiple-input-front-item tw-h-full" @click="onClickedFrontItem()">
      <slot name="front-item"></slot>
    </div>
    <div v-if="isVisible" class="neuron-multiple-input-group-popup !tw-w-full tw-p-1 tw-py-4">
      <slot name="group"></slot>
    </div>
  </div>
</template>

<script lang="ts">
import { SubComponentMixin } from '~/mixins/subComponent.mixin';
import { clickingOutsideDirective } from '~/units/core/directives/clickingOutside.directive';

export default {
  name: 'MultipleInputGroup',

  directives: {
    clickingOutsideDirective,
  },

  mixins: [SubComponentMixin],

  props: {
    popupWidth: {
      required: false,
      default: '100%',
      type: String,
    },

    isPopupManageableByParent: {
      required: false,
      default: false,
      type: Boolean,
    },

    isPopupVisibleParent: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  emits: ['onClickOutside'],

  data() {
    return {
      isPopupVisible: false,
    };
  },

  computed: {
    style() {
      return {
        '--popup-width': this.popupWidth,
      };
    },

    isVisible() {
      if (this.isPopupManageableByParent) {
        return this.isPopupVisibleParent;
      }
      return this.isPopupVisible;
    },
  },

  methods: {
    onClickedOutside() {
      this.isPopupVisible = false;
      this.$emit('onClickOutside');
    },

    onClickedFrontItem() {
      this.isPopupVisible = !this.isPopupVisible;
    },
  },
};
</script>

<style scoped>
.neuron-multiple-input-group {
  position: relative;
}

.neuron-multiple-input-group-popup {
  position: absolute;
  top: calc(100% + 1rem);
  z-index: 30;
  left: 0;
  box-shadow: 12px 10px 45px rgba(217, 221, 225, 0.49);
  transition:
    opacity 0.3s,
    transform 0.3s,
    visibility 0s,
    z-index 0s ease-in,
    -webkit-transform 0.3s;
  background-color: var(--white);
  width: var(--popup-width);
  max-height: 250px;
  overflow-y: auto;
  border-radius: 7px;
  border: 1px solid #dcdcdc;
}

.neuron-multiple-input-group-item {
}

.neuron-multiple-input-group-item:hover {
  background-color: #f8f8f8;
}
</style>
